import React, { useState } from "react";
import "./SettingsStyles.css";
import CardLayout from "../../common/cardLayout/CardLayout";
import PillButton from "../../common/PillButton";
import { ReactComponent as PencilIcon } from "../../../assets/icons/Pencil.svg";
import { useSelector, useDispatch } from "react-redux";
import { getFullName, getInitials } from "../../../util/helpers";
import { saveProfileLogic } from "../../../store/features/app/appSlice";
const Profile = (props) => {
  const { user, selectedClinic } = useSelector((state) => state.app);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    first_name: user?.first_name,
    last_name: user?.last_name,
    cell_number: user?.cell_number,
    address_line: user?.address_line,
    address_city: user?.address_city,
    address_state: user?.address_state,
  });
  const fullname = getFullName(user);
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      saveProfileLogic({
        formData: formData,
        clinicId: selectedClinic?.clinic_admin,
      })
    );
  };
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };
  return (
    <CardLayout>
      <div className="container-fluid d-flex justify-content-start w-100 py-3">
        <h5 className="muted-text">Basic Info</h5>
      </div>
      <div className="d-flex justify-content-center">
        <div className="container">
          <img
            src={`https://placehold.co/150x150/f1f1f5/395E9D/?text=${getInitials(
              fullname
            )}`}
            style={{
              borderRadius: "100%",
              display: "block",
              marginBottom: "5%",
            }}
          />
          {/* REMOVED SINCE THERE IS NO SUCH BACKEND FUNCTIONALITY */}
          {/* <PillButton
            text={"Change Picture"}
            icon={
              <PencilIcon style={{ marginLeft: "4px", marginTop: "-4px" }} />
            }
            handleClick={() => {}}
          /> */}
        </div>
      </div>
      <form onSubmit={handleSubmit} className="container-fluid row">
        <div className="col-sm-12 col-md-6 col-lg-6">
          <div className="form-group my-3">
            <label>First Name</label>
            <input
              name="first_name"
              id="first_name"
              placeholder="Enter First Name"
              value={formData?.first_name}
              onChange={handleChange}
            />
          </div>
          <div className="form-group my-3">
            <label>Phone Number</label>
            <input
              placeholder="Enter Phone Number"
              id="cell_number"
              name="cell_number"
              value={formData?.cell_number}
              onChange={handleChange}
            />
          </div>
          <div className="form-group my-3">
            <label>City</label>
            <input
              placeholder="Enter City"
              id="address_city"
              name="address_city"
              value={formData?.address_city}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-6">
          <div className="form-group my-3">
            <label>Last Name</label>
            <input
              placeholder="Enter Last Name"
              id="last_name"
              name="last_name"
              value={formData?.last_name}
              onChange={handleChange}
            />
          </div>
          <div className="form-group my-3">
            <label>Address</label>
            <input
              placeholder="Enter Address"
              id="address_line"
              name="address_line"
              value={formData?.address_line}
              onChange={handleChange}
            />
          </div>
          <div className="form-group my-3">
            <label>State</label>
            <input
              placeholder="Enter State"
              id="address_state"
              name="address_state"
              value={formData?.address_state}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="container-fluid d-flex justify-content-end my-5">
          <button type="submit" className="btn primary-btn">
            Save Changes
          </button>
        </div>
      </form>
    </CardLayout>
  );
};

export default Profile;
